import { Callout, Icon, IconButton, icons, theme } from '@agentisai/design-system';

export interface AttachErrorAlertProps {
  /** User-facing failure copy, already crafted by the caller. */
  readonly message: string;
  /** Clear the error. */
  readonly onDismiss: () => void;
}

/**
 * The attach-failure callout with a ✕ beside it.
 *
 * The dismiss affordance is the whole point: this callout lives in the band
 * ABOVE the composer, which grows with its content — a multi-file rejection
 * pushed the input out of reach with no way to clear it but leaving the
 * workstream (losing the typed prompt). `Callout` is deliberately static
 * document chrome in the DS, so the ✕ is composed here rather than added to it.
 *
 * The caller keeps its own padded `role="alert"` wrapper — the two composer
 * surfaces sit at different points in the chrome band and inset differently.
 */
export function AttachErrorAlert({ message, onDismiss }: AttachErrorAlertProps) {
  return (
    <div style={{ display: 'flex', alignItems: 'flex-start', gap: theme.space[1] }}>
      <div style={{ flex: 1, minWidth: 0 }}>
        <Callout tone="danger">{message}</Callout>
      </div>
      <IconButton
        aria-label="Dismiss attachment error"
        size="sm"
        variant="ghost"
        icon={<Icon as={icons.X} size={14} />}
        onClick={onDismiss}
      />
    </div>
  );
}
AttachErrorAlert.displayName = 'AttachErrorAlert';
